const STORAGE_KEY = "strataworks-consumable-pricing";
const SEED_VERSION_KEY = "strataworks-pricing-seed-version";
const CURRENT_VERSION = "v1-trial-orders-2026";

type ConsumableType = "drill-bit" | "hammer" | "drill-rod" | "drive-chuck" | "retaining-ring" | "sub";

interface ConsumablePrice {
  id: string;
  type: ConsumableType;
  subType: string;
  faceDesign: string;
  retrac: boolean;
  diameter: string;
  description: string;
  manufacturer: string;
  unitCost: string;
}

const TYPE_NORMALISE: Record<string, ConsumableType> = {
  "drill-bit": "drill-bit",
  "hammer": "hammer",
  "drill-rod": "drill-rod",
  "drive-chuck": "drive-chuck",
  "retaining-ring": "retaining-ring",
  "sub": "sub",
};

function parseCSVLine(line: string): string[] {
  const result: string[] = [];
  let cur = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (!inQuotes && cur === "") {
        inQuotes = true;
      } else if (inQuotes && line[i + 1] === '"') {
        cur += '"'; i++;
      } else if (inQuotes) {
        inQuotes = false;
      } else {
        cur += ch;
      }
    } else if (ch === "," && !inQuotes) {
      result.push(cur.trim());
      cur = "";
    } else {
      cur += ch;
    }
  }
  result.push(cur.trim());
  return result;
}

export async function seedTrialPricing(): Promise<void> {
  const existingVersion = localStorage.getItem(SEED_VERSION_KEY);
  if (existingVersion === CURRENT_VERSION) return;

  try {
    const resp = await fetch("/trial-supplier-pricing.csv");
    if (!resp.ok) return;
    const text = await resp.text();
    const lines = text.replace(/^\uFEFF/, "").split(/\r?\n|\r/).filter(l => l.trim());
    if (lines.length < 2) return;

    const headers = parseCSVLine(lines[0]).map(h => h.toLowerCase().trim());
    const idx = (name: string) => headers.indexOf(name.toLowerCase());

    const entries: ConsumablePrice[] = [];
    for (let i = 1; i < lines.length; i++) {
      const cols = parseCSVLine(lines[i]);
      const get = (name: string) => (cols[idx(name)] ?? "").trim();
      const rawType = get("type").toLowerCase();
      const type = TYPE_NORMALISE[rawType];
      if (!type) continue;

      entries.push({
        id: Math.random().toString(36).slice(2) + i.toString(36),
        type,
        subType: get("subtype"),
        faceDesign: get("facedesign"),
        retrac: get("retrac").toLowerCase() === "true",
        diameter: get("diameter"),
        description: get("description"),
        manufacturer: get("manufacturer"),
        unitCost: get("unitcost"),
      });
    }

    if (entries.length > 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
      localStorage.setItem(SEED_VERSION_KEY, CURRENT_VERSION);
      console.log(`Seeded ${entries.length} trial supplier pricing entries`);
    }
  } catch (err) {
    console.warn("Failed to seed trial pricing:", err);
  }
}
